import { ref } from "vue";

/**
 * 画面ロジックを扱う composable。
 */
export const useAreaListUiState = () => {
  const tab = ref('formTab');
  const errdialog = ref(false);
  const errMessage = ref<string>("");
  const overlay = ref(false);
  const processFlag = ref(0); // 0:新規、1:編集、2:削除
  const displayInputDialog = ref(false);
  const displayConfirmDialog = ref(false);
  const displayCompletedDialog = ref(false);
  const displayConfirmDialogSectionUnassigned = ref(false);
  const displayConfirmDialogSectionAssigned = ref(false);
  const displayDialogDownloadSectionAssigned = ref(false);
  const uploadDialog = ref(false);
  const messagedialog = ref(false);
  const message = ref<string>("");

  return {
    tab,
    errdialog,
    errMessage,
    overlay,
    processFlag,
    displayInputDialog,
    displayConfirmDialog,
    displayCompletedDialog,
    displayConfirmDialogSectionUnassigned,
    displayConfirmDialogSectionAssigned,
    displayDialogDownloadSectionAssigned,
    uploadDialog,
    messagedialog,
    message,
  };
};
